export const calculateAge = (birthDate, format = "YYYY-MM-DD") => {
    // Verificar el formato y convertir la fecha de nacimiento
    let birth;
    if (format === "YYYY-MM-DD") {
        birth = new Date(birthDate);
    } else {
        throw new Error("Formato de fecha no soportado");
    }

    if (isNaN(birth)) {
        return '';
    }

    // Obtener la fecha actual
    const now = new Date();

    // Calcular la diferencia de años
    let age = now.getFullYear() - birth.getFullYear();

    // Ajustar si el cumpleaños aún no ha ocurrido este año
    if (
        now.getMonth() < birth.getMonth() ||
        (now.getMonth() === birth.getMonth() && now.getDate() < birth.getDate())
    ) {
        age--;
    }

    return age;
}

export const formatDate = (dateString) => {
    if (!dateString || dateString === '0000-00-00' || dateString === '0000-00-00 00:00:00') {
        return '';
    }

    const date = new Date(dateString);
    // Verificamos si la fecha es válida
    if (isNaN(date.getTime())) {
        return ''; // O puedes devolver 'Sin fecha' si prefieres ese mensaje
    }

    // Asegurarse de que el día y el mes sean en formato local
    const day = String(date.getUTCDate()).padStart(2, '0'); // Fecha local
    const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Los meses empiezan desde 0, por lo que se suma 1
    const year = date.getUTCFullYear(); // Año en formato UTC (ya que no importa la zona horaria)

    return `${day}-${month}-${year}`;
}

export const formatMonthDate = (fechaISO) => {
    const meses = [
        "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
        "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
    ];
    const [anio, mes, dia] = fechaISO.split("-");
    return `${meses[parseInt(mes) - 1]}`;
};

export const formatDateTime = (dateString) => {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
        return '';
    }
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${day}-${month}-${year} ${hours}:${minutes}`;
}

export const formatMoney = (number) => {
    if (number == '' || number == undefined || number == null) {
        return 0;
    }
    // Redondea el número a un entero
    const sanitizedNumber = Number(number.toString().replace(/,/g, '.'));
    const roundedNumber = Math.round(sanitizedNumber);

    // Añade puntos como separadores de miles
    const formattedNumber = roundedNumber.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');

    return formattedNumber;
}

export const formatFechaES = (fechaIso) => {
    const diasSemana = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
    const meses = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
        'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];

    // Desglosamos la cadena "YYYY-MM-DD"
    const [year, month, day] = fechaIso.split('-').map(n => parseInt(n, 10));

    // Creamos el objeto Date (ojo: month es 0-based)
    const fecha = new Date(year, month - 1, day);

    // Nombre del día y del mes
    const nombreDia = diasSemana[fecha.getDay()];
    const nombreMes = meses[month - 1];

    // Día con dos dígitos
    const diaFormateado = String(day).padStart(2, '0');

    return `${nombreDia} ${diaFormateado} de ${nombreMes} del ${year}`;
}
